import { ONSEASON_CONFIG } from './config';

export const NAVIGATION_STATES = Object.freeze({
  VISIBLE: 'visible',
  ADMIN_ONLY: 'admin_only',
  HIDDEN: 'hidden',
  DISABLED: 'disabled',
});

const stateFor = name =>
  ONSEASON_CONFIG.navigation[name] || NAVIGATION_STATES.VISIBLE;

export const canDisplayNavigationItem = (name, { isAdmin = false } = {}) => {
  const state = stateFor(name);

  if (
    state === NAVIGATION_STATES.HIDDEN ||
    state === NAVIGATION_STATES.DISABLED
  ) {
    return false;
  }

  return state !== NAVIGATION_STATES.ADMIN_ONLY || isAdmin;
};

export const filterNavigationItems = (items, context = {}) =>
  items
    .filter(item => canDisplayNavigationItem(item.name, context))
    .map(item => {
      if (!item.children) return item;

      return {
        ...item,
        children: filterNavigationItems(item.children, context),
      };
    });

const routeMatches = (routeName, exactNames = [], prefixes = []) =>
  exactNames.includes(routeName) ||
  prefixes.some(prefix => routeName.startsWith(prefix));

export const resolveRouteAccess = (routeName, { isAdmin = false } = {}) => {
  if (!routeName) return { allowed: true, state: NAVIGATION_STATES.VISIBLE };

  const routes = ONSEASON_CONFIG.routes;

  if (routeMatches(routeName, routes.disabled, routes.disabled_prefixes)) {
    return { allowed: false, state: NAVIGATION_STATES.DISABLED };
  }

  if (routeMatches(routeName, routes.admin_only, routes.admin_only_prefixes)) {
    return {
      allowed: isAdmin,
      state: NAVIGATION_STATES.ADMIN_ONLY,
    };
  }

  return { allowed: true, state: NAVIGATION_STATES.VISIBLE };
};
